import React from "react";
import Modal from "../../../components/Reusable/Modal";
import { SupportItem } from "../../../features/auth/store/types/support-types";

interface ViewSupportModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: SupportItem | null;
}

const ViewSupportModal: React.FC<ViewSupportModalProps> = ({
  isOpen,
  onClose,
  item,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="w-full max-w-2xl mx-4 my-auto p-4 sm:p-6"
    >
      <h2 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6">
        Support Item
      </h2>

      <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-1">
        <div>
          <p className="text-[10px] sm:text-xs font-semibold uppercase text-gray-400 dark:text-gray-500 mb-1">
            Question
          </p>
          <p className="text-xs sm:text-sm text-gray-800 dark:text-white font-medium break-words">
            {item?.question}
          </p>
        </div>

        <div className="border-t border-[#D0D5DD] dark:border-[#FFFFFF1A]" />

        <div>
          <p className="text-[10px] sm:text-xs font-semibold uppercase text-gray-400 dark:text-gray-500 mb-2">
            Answer
          </p>
          <div
            className="text-xs sm:text-sm text-gray-700 dark:text-gray-300 prose prose-sm max-w-none dark:prose-invert break-words [&_a]:text-blue-600 dark:[&_a]:text-blue-400 [&_a]:no-underline hover:[&_a]:text-blue-700 dark:hover:[&_a]:text-blue-300"
            dangerouslySetInnerHTML={{ __html: item?.answer ?? "" }}
          />
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-end mt-6">
        <button
          type="button"
          onClick={onClose}
          className="w-full sm:w-auto text-center px-4 py-2.5 sm:py-2 border border-[#D0D5DD] dark:border-[#FFFFFF1A] rounded-lg text-sm font-medium dark:text-white"
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default ViewSupportModal;
